import { Box, Typography } from '@mui/material';
import { ModalContainer } from '@tassomutuo-backoffice/ui';
import image from '../../../assets/images/tasso-student.png';

interface IProps {
  open: boolean;
  onClose: () => void;
}

const DashboardLegendCardModal = ({ open, onClose }: IProps) => {
  return (
    <ModalContainer
      open={open}
      handleClose={onClose}
      title=""
      mtHeader={1}
      containerSx={{
        borderRadius: '30px',
        maxWidth: '600px',
        overflow: 'auto',
        scrollbarWidth: 'none', // Firefox
        '&::-webkit-scrollbar': {
          display: 'none', // Chrome, Safari
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          px: 2,
        }}
      >
        <Box
          component="img"
          src={image}
          sx={{ width: '120px', mb: 2, alignSelf: 'center' }}
        ></Box>
        <Typography variant="h5" fontWeight="bold" textAlign="center">
          Legenda card:
        </Typography>

        <Typography mt={1}>
          <Box component="span" sx={{ fontWeight: 'bold', fontSize: 14 }}>
            Lead Ricevute:
          </Box>{' '}
          Indica il numero di lead assegnate nel periodo di riferimento.
        </Typography>

        <Typography mt={1}>
          <Box component="span" sx={{ fontWeight: 'bold', fontSize: 14 }}>
            Mutui stimati:
          </Box>{' '}
          Somma delle probabilità di chiusura dei lead per stimare il numero di
          mutui conclusi. Esempio: 10 lead in "sviluppo" (10% probabilità) = 1
          mutuo atteso.
        </Typography>

        <Typography mt={1}>
          <Box component="span" sx={{ fontWeight: 'bold', fontSize: 14 }}>
            Tasso di conversione stimato:
          </Box>{' '}
          rapporto tra mutui stimati e le lead ricevute
        </Typography>

        <Typography mt={1}>
          <Box component="span" sx={{ fontWeight: 'bold', fontSize: 14 }}>
            Revenue totale stimato:
          </Box>{' '}
          fatturato atteso, calcolato per ogni lead moltiplicando il fatturato
          stimato (media Euroansa \* importo mutuo) per la probabilità di
          chiusura (in base alla fase) e sommando i risultati di tutte le lead
          assegnate.
        </Typography>

        <Typography mt={1}>
          <Box component="span" sx={{ fontWeight: 'bold', fontSize: 14 }}>
            Revenue per lead:
          </Box>{' '}
          fatturato medio previsto per contatto, calcolato dividendo il
          fatturato stimato totale per il numero di lead. Indica il valore medio
          di ogni lead in relazione al lavoro complessivo sul portafoglio.
        </Typography>

        <Typography mt={1}>
          <Box component="span" sx={{ fontWeight: 'bold', fontSize: 14 }}>
            Fatturato totale effettivo:
          </Box>{' '}
          Rappresenta il fatturato generato dalle lead assegnate nel periodo di
          riferimento.
        </Typography>
      </Box>
    </ModalContainer>
  );
};

export default DashboardLegendCardModal;
